module.exports = __webpack_public_path__ + "static/media/jx-map-video.659df0b.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/mapPicture/jx-map-video.mp4
// module id = c8Vd
// module chunks = 6